export default "__VITE_ASSET__462999e3__"